<section>
  <div class="container-fluid bg-lightgrey py-5">
    <h1 class="h3 text-center">Contatti</h1>
  </div>
  <div class="container-narrow py-5">
    <p>
      <b><a href="https://www.actionaid.it">ActionAid International Italia E.T.S.</a></b><br>
      Via Carlo Tenca, 14 <br>
      20124 Milano<br>
      Codice fiscale 09686720153<br>
      E-mail: ufficiostampa@actionaid.org<br>
      Tel: +39 02 742001
    </p>
    <p>
      <b><a href="https://www.openpolis.it/">Fondazione openpolis</a></b><br>
      Via Merulana, 19 <br>
      00185 Roma<br>
      Codice fiscale 97954040586<br>
      Tel: +39 06 53096405<br>
      <a href="https://fondazione.openpolis.it/contactus" target="_blank">Contattaci</a>
    </p>
  </div>
</section>
